import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React from "react";
import { CustomerBooking } from "rsl-api-106/lib/types";

import { StepTitle } from "@components/Reservation/Steps";
import { useSession } from "@hooks";

import StayOccupants from "../StayOccupants";

type ReservationOccupantsProps = {
  reservation: CustomerBooking;
  btnAddOccupantText: string;
  loadingAddingOccupantText: string;
  successfullyOccupantAddedText: string;
  productListTitle: string;
  btnAddBabyText: string;
  loadingAddingBabyText: string;
  successfullyBabyAddedText: string;
  showProductOccupant?: boolean;
  showTitle?: boolean;
  showInfoOccupant?: boolean;
  showValidity?: boolean;
  columnReverse?: boolean;
  showAddOccupant?: boolean;
  disableEditFirstOccupant?: boolean;
};

const languagesVarsCodes = [
  "LANG_neobooking_occupants_fill_occupants", //Renseignez les occupants
];

const ReservationOccupants: React.FC<ReservationOccupantsProps> = ({
  reservation,
  btnAddOccupantText,
  productListTitle,
  successfullyOccupantAddedText,
  loadingAddingOccupantText,
  btnAddBabyText,
  loadingAddingBabyText,
  successfullyBabyAddedText,
  showProductOccupant,
  showInfoOccupant = true,
  showTitle = true,
  showValidity = false,
  columnReverse = false,
  showAddOccupant = true,
  disableEditFirstOccupant = false,
}) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  /* Render */
  return (
    <div
      className="tw-flex tw-flex-col tw-gap-y-4"
      key={`${reservation?.property?.id}`}
    >
      {reservation?.stays?.map((stay, stayIndex) => {
        return (
          <React.Fragment key={`rs_${stayIndex}_${stay?.guiid}`}>
            {showTitle && showTitle ? (
              <>
                {!isEmpty(reservation.stays) &&
                (reservation.stays?.length ?? -1 > 0) ? (
                  <StepTitle
                    className="tw-mb-4"
                    subtitle={
                      !isEmpty(stay?.distribution?.roomTypes)
                        ? stay?.distribution?.roomTypes?.[0]?.label
                          ? stay?.distribution?.roomTypes?.[0]?.label
                          : getLanguageVarValue(
                              "LANG_neobooking_occupants_fill_occupants"
                            )
                        : getLanguageVarValue(
                            "LANG_neobooking_occupants_fill_occupants"
                          )
                    }
                  />
                ) : (
                  <StepTitle
                    className="tw-mb-4"
                    subtitle={getLanguageVarValue(
                      "LANG_neobooking_occupants_fill_occupants"
                    )}
                  />
                )}
              </>
            ) : (
              <></>
            )}
            <StayOccupants
              cartItemID={reservation.cartItemID!!}
              stay={stay!!}
              etabName={reservation?.property?.label!!}
              productListTitle={productListTitle}
              loadingAddingOccupantText={loadingAddingOccupantText}
              successfullyOccupantAddedText={successfullyOccupantAddedText}
              btnAddOccupantText={btnAddOccupantText}
              loadingAddingBabyText={loadingAddingBabyText}
              successfullyBabyAddedText={successfullyBabyAddedText}
              btnAddBabyText={btnAddBabyText}
              showProducts={showProductOccupant}
              showValidity={showValidity}
              columnReverse={columnReverse}
              showInfoOccupant={showInfoOccupant}
              showAddOccupant={showAddOccupant}
              disableEditFirstOccupant={disableEditFirstOccupant}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};

ReservationOccupants.propTypes = {
  //
};

export default ReservationOccupants;
